exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".box-buy {\n  padding: 10px;\n  border: 1px dotted #f52606;\n}\n\n.alert {\n  margin-top: 10px;\n}\n\n.checkbox-wrap {\n  border: 1px dotted #c3c5c6;\n  padding: 10px;\n  width: 100%;\n}\n\n.table tr:first-child td {\n  border-top: none !important;\n}\n\n.custom-control-input:checked ~ .custom-control-label::before {\n  color: #fff;\n  border-color: #7b1fa2;\n}\n\n.custom-control-input:checked ~ .custom-control-label.red::before {\n  background-color: red;\n}\n\n.custom-control-input:checked ~ .custom-control-label.green::before {\n  background-color: green;\n}\n\nlabel,\ninput {\n  /* added because a second click to unselect radio often\n     appears as a double click to select text */\n  -webkit-user-select: none;\n  -moz-user-select: none;\n   -ms-user-select: none;\n       user-select: none;\n}\n\n.activeStamp {\n  min-width: 190px;\n}\n\n.priority {\n  margin: 12px 0px 0px;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /app/src/app/pages/admin/qrcode/integrate-loyalty/config-loyalty/config-loyalty.component.css
// module id = ../../../../../src/app/pages/admin/qrcode/integrate-loyalty/config-loyalty/config-loyalty.component.css
// module chunks = 3